/* eslint-disable max-len */
import React from 'react';

export default function SurveyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="62"
      fill="none"
      viewBox="0 0 52 62"
    >
      <path
        fill="url(#paint0_linear_10353_4277)"
        d="M2.794 61.727h37.585a2.794 2.794 0 002.794-2.794V2.793A2.794 2.794 0 0040.379 0H2.794A2.794 2.794 0 000 2.794v56.139a2.794 2.794 0 002.794 2.794z"
      />
      <path
        fill="url(#paint1_linear_10353_4277)"
        d="M1.652.244a2.78 2.78 0 00-.46 1.536v56.14a2.794 2.794 0 002.794 2.793H41.57c.407 0 .793-.088 1.142-.244a2.79 2.79 0 01-2.333 1.257H2.794A2.794 2.794 0 010 58.932V2.793C0 1.657.68.68 1.652.243z"
      />
      <path
        fill="url(#paint2_linear_10353_4277)"
        d="M0 58.933V8.286L3.615 4.67v50.247a2.626 2.626 0 002.626 2.626h36.931v1.389a2.794 2.794 0 01-2.793 2.794H2.794A2.794 2.794 0 010 58.933z"
      />
      <path
        fill="url(#paint3_linear_10353_4277)"
        d="M14.344 2.2a2.597 2.597 0 012.069-1.026h14.594a2.604 2.604 0 012.604 2.604v.228c0 .845-.404 1.593-1.027 2.07L7.99 30.668a2.596 2.596 0 01-2.068 1.027H0V16.545L14.344 2.2z"
      />
      <path
        fill="url(#paint4_linear_10353_4277)"
        d="M7.778 59.607h37.097V7.244a3.662 3.662 0 00-3.662-3.662H6.23a3.685 3.685 0 00-3.685 3.685v47.107a5.233 5.233 0 005.233 5.233z"
      />
      <path
        fill="url(#paint5_linear_10353_4277)"
        d="M38.842 5.954a3.662 3.662 0 013.662 3.662v49.992H7.778a5.233 5.233 0 01-5.233-5.234V7.267c0-.396.063-.777.179-1.135a3.68 3.68 0 011.135-.179h34.983z"
      />
      <path
        fill="url(#paint6_linear_10353_4277)"
        d="M3.615 57.544l9.516-9.516c.2-.297.54-.492.924-.492h30.82v12.072H7.778a5.224 5.224 0 01-4.163-2.064z"
      />
      <path
        fill="url(#paint7_linear_10353_4277)"
        d="M7.71 59.608h39.056A5.234 5.234 0 0052 54.374v-5.726c0-.614-.498-1.112-1.112-1.112H14.055c-.615 0-1.113.498-1.113 1.112v5.726a5.233 5.233 0 01-5.232 5.234z"
      />
      <path
        fill="url(#paint8_linear_10353_4277)"
        d="M7.223 59.585v.023h.487c-.164 0-.326-.008-.487-.023z"
      />
      <path
        fill="#BEC3D2"
        d="M22.429 44.667h15.723c.269 0 .487-.218.487-.487v-1.442a.487.487 0 00-.487-.487H22.429a.487.487 0 00-.488.487v1.442c0 .27.219.487.488.487zM14.601 44.667h4.876c.269 0 .487-.218.487-.487v-1.442a.487.487 0 00-.487-.487H14.6a.487.487 0 00-.487.487v1.442c0 .27.218.487.487.487zM9.268 44.667h2.538c.27 0 .488-.218.488-.487v-1.442a.487.487 0 00-.488-.487H9.268a.487.487 0 00-.487.487v1.442c0 .27.218.487.487.487zM14.64 29.977h15.722c.27 0 .488-.219.488-.488v-1.442a.487.487 0 00-.488-.487H14.64a.487.487 0 00-.487.487v1.442c0 .27.218.488.487.488zM33.276 29.977h4.876c.269 0 .487-.219.487-.488v-1.442a.487.487 0 00-.487-.487h-4.876a.487.487 0 00-.487.487v1.442c0 .27.218.488.487.488zM9.268 29.977h2.538c.27 0 .488-.219.488-.488v-1.442a.487.487 0 00-.488-.487H9.268a.487.487 0 00-.487.487v1.442c0 .27.218.488.487.488zM24.991 20.215H9.268a.487.487 0 00-.487.488v1.442c0 .269.218.487.487.487h15.723c.27 0 .488-.218.488-.487v-1.442a.487.487 0 00-.488-.488zM32.819 20.215h-4.875a.487.487 0 00-.488.488v1.442c0 .269.218.487.488.487h4.875c.269 0 .487-.218.487-.487v-1.442a.487.487 0 00-.487-.488zM38.152 20.215h-2.538a.488.488 0 00-.487.488v1.442c0 .269.218.487.487.487h2.538c.269 0 .487-.218.487-.487v-1.442a.488.488 0 00-.487-.488zM32.78 34.906H17.059a.487.487 0 00-.488.487v1.442c0 .27.219.488.488.488H32.78c.27 0 .487-.219.487-.488v-1.442a.487.487 0 00-.487-.487zM14.143 34.906H9.268a.487.487 0 00-.487.487v1.442c0 .27.218.488.487.488h4.875c.27 0 .488-.219.488-.488v-1.442a.487.487 0 00-.488-.487zM38.152 34.906h-2.538a.487.487 0 00-.487.487v1.442c0 .27.218.488.487.488h2.538c.269 0 .487-.219.487-.488v-1.442a.487.487 0 00-.487-.487z"
      />
      <path
        fill="url(#paint9_linear_10353_4277)"
        d="M2.545 31.695V14L12.963 3.582H33.6c.005.064.01.13.01.195v.229c0 .845-.404 1.593-1.027 2.069L7.99 30.668a2.596 2.596 0 01-2.068 1.027H2.545z"
      />
      <path
        fill="#555A66"
        d="M17.76 9.861h11.9a2.93 2.93 0 002.927-2.927V3.098H14.833v3.836A2.93 2.93 0 0017.76 9.86zm13.859-5.794v2.867c0 1.08-.879 1.959-1.959 1.959h-11.9a1.961 1.961 0 01-1.959-1.96V4.068h15.818z"
      />
      <path
        fill="url(#paint10_linear_10353_4277)"
        d="M16.413 6.61h14.594a2.604 2.604 0 002.604-2.604v-.228a2.604 2.604 0 00-2.604-2.604H16.412a2.604 2.604 0 00-2.603 2.604v.228a2.604 2.604 0 002.604 2.604z"
      />
      <path
        fill="url(#paint11_linear_10353_4277)"
        d="M30.025 2.157a2.604 2.604 0 012.604 2.604v.229c0 .466-.125.903-.34 1.282-.378.215-.815.339-1.282.339H16.413a2.604 2.604 0 01-2.604-2.604v-.229c0-.466.124-.903.34-1.282.378-.215.815-.34 1.281-.34h14.595v.001z"
      />
      <path
        fill="url(#paint12_linear_10353_4277)"
        d="M16.413 1.174h.262a3.905 3.905 0 003.78 4.887h12.147a2.59 2.59 0 01-1.595.55H16.413a2.604 2.604 0 01-2.604-2.605v-.228a2.604 2.604 0 012.604-2.604z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10353_4277"
          x1="37.375"
          x2="-5.682"
          y1="13.783"
          y2="60.365"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDAAA" />
          <stop offset="0.421" stopColor="#FFD8A8" />
          <stop offset="0.652" stopColor="#FED1A0" />
          <stop offset="0.836" stopColor="#FDC592" />
          <stop offset="0.995" stopColor="#FCB47F" />
          <stop offset="1" stopColor="#FCB37E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10353_4277"
          x1="-7.284"
          x2="52.879"
          y1="45.876"
          y2="14.591"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCB37E" stopOpacity="0" />
          <stop offset="1" stopColor="#FF7044" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10353_4277"
          x1="4.777"
          x2="33.723"
          y1="48.86"
          y2="23.318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCB37E" stopOpacity="0" />
          <stop offset="1" stopColor="#FF7044" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10353_4277"
          x1="12.992"
          x2="26.988"
          y1="14.782"
          y2="0.153"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCB37E" stopOpacity="0" />
          <stop offset="1" stopColor="#FF7044" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10353_4277"
          x1="50.941"
          x2="-1.787"
          y1="0.511"
          y2="62.961"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F7FC" />
          <stop offset="1" stopColor="#F0DDFC" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_10353_4277"
          x1="20.52"
          x2="56.77"
          y1="34.802"
          y2="1.353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9EDF5" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_10353_4277"
          x1="11.16"
          x2="28.327"
          y1="71.646"
          y2="54.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0DDFC" stopOpacity="0" />
          <stop offset="0.289" stopColor="#C8B7E0" stopOpacity="0.289" />
          <stop offset="0.592" stopColor="#A595C8" stopOpacity="0.592" />
          <stop offset="0.84" stopColor="#8F81B8" stopOpacity="0.84" />
          <stop offset="1" stopColor="#8779B3" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_10353_4277"
          x1="29.855"
          x2="29.855"
          y1="51.555"
          y2="57.292"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F7FC" />
          <stop offset="1" stopColor="#F0DDFC" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_10353_4277"
          x1="7.549"
          x2="7.285"
          y1="59.514"
          y2="59.778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F7FC" />
          <stop offset="1" stopColor="#F0DDFC" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_10353_4277"
          x1="16.845"
          x2="23.178"
          y1="12.572"
          y2="-4.57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0DDFC" stopOpacity="0" />
          <stop offset="0.289" stopColor="#C8B7E0" stopOpacity="0.289" />
          <stop offset="0.592" stopColor="#A595C8" stopOpacity="0.592" />
          <stop offset="0.84" stopColor="#8F81B8" stopOpacity="0.84" />
          <stop offset="1" stopColor="#8779B3" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_10353_4277"
          x1="23.881"
          x2="23.459"
          y1="1.731"
          y2="7.051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#18CFFC" />
          <stop offset="1" stopColor="#4A98F7" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_10353_4277"
          x1="22.661"
          x2="29.754"
          y1="5.088"
          y2="-3.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#18CFFC" stopOpacity="0" />
          <stop offset="1" stopColor="#65E1DC" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_10353_4277"
          x1="22.628"
          x2="20.433"
          y1="2.745"
          y2="-6.543"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0469BC" stopOpacity="0" />
          <stop offset="1" stopColor="#0469BC" />
        </linearGradient>
      </defs>
    </svg>
  );
}
